import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "@mui/material";
import i18next from "i18next";

const OtherGrantQuestions = ({ t }) => {
  return (
    <div className="row" style={{ paddingTop: ".5em", paddingBottom: ".5em" }}>
      <div className="col-xs-12 col-sm-8">
        <h3>{t("otherGrantQuestions.other_grants_header")}</h3>
        {/* </div> */}

        {/* <div className="col-xs-12" style={{ display: "flex" }}> */}
        {/* <div className="col-xs-12"> */}
        <p>{t("otherGrantQuestions.other_grants_para_1")}</p>
        <h5>
          {t("otherGrantQuestions.other_grants_1")}{" "}
          <Link
            href="https://medium.com/nova-scotia-consumer-protection/benefits-available-to-nova-scotia-residents-8b00c7fde529"
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: "pointer" }}
          >
            {t("otherGrantQuestions.other_grants_1_link")}
          </Link>{" "}
          {i18next.language === "fr" &&
            t("otherGrantQuestions.additional_text")}
        </h5>
      </div>
      <div className="col-xs-12 col-sm-8">
        <h5>
          <Link
            href="https://ns.211.ca/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: "pointer" }}
          >
            {t("otherGrantQuestions.other_grants_2_link")}
          </Link>{" "}
          {t("otherGrantQuestions.other_grants_2")}
        </h5>
      </div>
    </div>
  );
};

export default withTranslation("common")(OtherGrantQuestions);
